__turbopack_context__.v({
  "buyComponentContainer": "BloodVisionPage-module__EtnjsG__buyComponentContainer",
  "notAvailableSection": "BloodVisionPage-module__EtnjsG__notAvailableSection",
  "primaryLink": "BloodVisionPage-module__EtnjsG__primaryLink",
});
